import Vue from 'vue'
import Vuex from 'vuex'
import i18n from '../translation'
import router from '../router'
import createPersistedState from 'vuex-persistedstate'
// import _watcheebox from '../components/watcheebox/watcheebox.js'
import _ from 'lodash'
/**
 * Modules Watcheezy
 */
import { _Toolbar } from './toolbar'
import { _Notifier } from './notifier'
import { _Dialog } from './dialog'
import { _User } from './user'
import { _Biblios } from './biblios'
import { _Rayons } from './rayons'
import { _Sites } from './sites'
import { _StoreWatcheeBox } from './storeWatcheeBox'
import { _Stats } from './stats'

Vue.use(Vuex)

/**
 * Instance de Vuex (store global) synchronisé avec une instance de vue-router afin de gérer le routing
 * et afin qu'il soit synchro avec le state général de l'application
 */
const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    _Toolbar,
    _Notifier,
    _Dialog,
    _User,
    _Biblios,
    _Rayons,
    _Sites,
    _StoreWatcheeBox,
    _Stats
  },
  state: {
    // indique si l'utilisateur est loggué
    logged: false,
    // indique la raison du rechargement de la page
    reasonUnload: null,
    // indique la raison de la deconnexion du BO
    reasonDeco: null
  },
  getters: {
    logged: state => state.logged
  },
  mutations: {
    loginUser (state, {user, path}) {
      state.logged = true
      i18n.locale = user.lang
      state._User = user
      router.push({ path: path })
    },
    logoutFreshdesk (state) {
      // console.log('logout Freshdesk')
      state.logged = false
      state._User = {}
    },
    // logoutBackEnd (state, rootState) {
    //   console.log('mutations logoutBackEnd --> logoutBackEnd', state)
    //   // this.$store.dispatch('_StoreWatcheeBox/removeAllChatsSession', this.$socket) // vuex action
    //   let goToAdmin = state._User.connectFromAdmin
    //   let id = state._User.entId
    //   state.logged = false
    //   state._User = {}
    //   // router.push({ path: '/login' })
    //   if (goToAdmin) {
    //     window.location.href = `https://adminv2.targetfirst.com/licence/licence_n.php?id=${id}`
    //   } else {
    //     // window.location.reload()
    //   }
    // },
    LOGOUT_BACKEND_MUTATION (state) {
      state.logged = false
      state._User = {}
    },

    SET_REASON_UNLOAD (state, reason) {
      state.reasonUnload = reason
    },
    SET_REASON_DECO (state, reason) {
      state.reasonDeco = reason
    }
  },
  actions: {
    logoutBackEnd ({ commit, dispatch, state }) {
      console.log('action logoutBackEnd')
      // 1️⃣ Actions du module WatcheeBox
      dispatch('_StoreWatcheeBox/removeAllChatsSession', null, { root: true })
      // dispatch('_StoreWatcheeBox/LOGOUT_SOCKET', null, { root: true })

      // 2️⃣ Mutation pour réinitialiser l’état du store principal
      commit('LOGOUT_BACKEND_MUTATION')

      // 3️⃣ Redirection
      const goToAdmin = state._User.connectFromAdmin
      const id = state._User.entId

      if (goToAdmin) {
        window.location.href = `https://adminv2.targetfirst.com/licence/licence_n.php?id=${id}`
      } else {
        window.location.reload()
      }
    },
    loginUser ({commit, dispatch}, user) {
      // console.log('user', user)
      commit('_Toolbar/INIT')
      commit('_Notifier/INIT')
      commit('_StoreWatcheeBox/INIT')
      commit('_Sites/INIT')
      // Lancement de plusieurs promesses simultanées
      Promise.all([
        dispatch('_Biblios/GET', user.id),
        dispatch('_Rayons/GET', user.id),
        dispatch('_Sites/GET_MAPPING'),
        dispatch('_Sites/GET')
      ]).then(() => {
        // tableau des agents du site
        // console.log('user.colleagues', user.colleagues)
        let arrayIdAgent = []
        // après avoir récupéré les sites
        // changement de route en fonction du role de l'agent
        let path = ''
        if (user.rights === '0' || user.rights === '1') {
          if (sessionStorage.getItem('tf-directChat')) {
            path = '/trafic/attente'
          } else {
            path = '/trafic/visitors'
          }
          arrayIdAgent.push(user.id) // simple agent : uniquement mes messages en attente
        } else {
          if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            console.log('je suis sur mobile', self.location.origin)
            if (sessionStorage.getItem('tf-directChat')) {
              path = '/trafic/attente'
            } else {
              path = '/trafic/visitors'
            }
          } else {
            console.log('je suis pas sur mobile', sessionStorage.getItem('tf-directChat'))
            if (sessionStorage.getItem('tf-directChat')) {
              path = '/trafic/attente'
            } else {
              if (user.welcome === 'botbuilder') {
                path = '/botbuilder/mind'
              } else if (user.welcome !== '') {
                path = '/' + user.welcome
              } else {
                path = '/stats/audience'
              }
            }
          }
          _.forEach(
            user.colleagues,
            (agent, key) => {
              arrayIdAgent.push(agent.USR_ID) // super agent : tous les messages en attente
            }
          )
        }
        console.log('arrayIdAgent', arrayIdAgent)
        commit('loginUser', {user: user, path: path})
        commit('_Stats/INIT')
        // liste des message en attente
        dispatch('_User/GET_COLLEAGUE_LISTEMESSAGES', arrayIdAgent)
        // liste des contacts reseaux sociaux
        dispatch('_StoreWatcheeBox/ACTION_GET_ALL_CONTACT_RESEAUX', user.entId)
      })
    },
/**
 * LogoutUser
 *
 * ferme la session du agent et deconnecte le socket
 * @param {object} commit - commit vuex
 * @param {object} state - state vuex
 * @param {object} socket - socket du store _StoreWatcheeBox
 */
    logoutUser ({commit, state}, socket) {
      console.log('action logoutUser', state._StoreWatcheeBox.sessionDejaActive)
      if (!state._StoreWatcheeBox.sessionDejaActive) {
        commit('_StoreWatcheeBox/SOCKET_DISCONNECT_CLIENT')
        // a ce niveau le socket est close
        // console.log('logoutUsersocket', socket)
        // if (socket) {
        //   _watcheebox.changeStatusAgent(
        //     {
        //       statut: 'offline',
        //       agentID: state._User.id,
        //       sessionsPrivees: [],
        //       roomName: state._User.entKey,
        //       socket: socket,
        //       sessionPHP: '' // efface la sessionPHP de l'agent dans redis
        //     }
        //   )
        // }
      }
      commit('_StoreWatcheeBox/INIT')
      commit('_Biblios/INIT')
      commit('_Rayons/INIT')
      commit('_Sites/INIT')
      commit('_Stats/INIT')
      commit('_Toolbar/INIT')
      commit('_Notifier/INIT')
      // commit('logoutBackEnd') // delog du backend et retourne sur le page login
    }
  },
  // Garder la persistance du store lors d'un refresh (dans le localStorage)
  plugins: [createPersistedState()]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js